import React, { ReactNode, useMemo, useState } from 'react';
import { createContext } from 'react';
import { useSafeContext } from '../../hooks/useSafeContext';

interface ITabsContext {
  activeTab: string;
  setActiveTab: (tabId: string) => void;
}

const TabsContext = createContext<ITabsContext | undefined>(undefined);

export const TabsProvider = ({ defaultTab, children }: { defaultTab: string; children: ReactNode }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const value = useMemo(() => ({ activeTab, setActiveTab }), [activeTab, setActiveTab]);

  return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
};

export const useTabs = () => useSafeContext('TabsProvider', TabsContext);
